import { Row } from "@tanstack/react-table";
import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { TAny } from "@/interfaces/globals";
import { cn } from "@/lib/utils";

interface CustomRightClickTypes {
  children: React.ReactNode;
  row?: Row<TAny>;
  data?: (row: Row<TAny> | undefined) => ActionButtonDataTypes[] | undefined;
}

const CustomRightClickActionBtn = ({
  children,
  row,
  data,
}: CustomRightClickTypes): React.JSX.Element => {
  const [handleContext, setHandleContext] = useState(false);

  return data?.(row)?.length ? (
    <ContextMenu modal={handleContext} onOpenChange={setHandleContext}>
      <ContextMenuTrigger
        onContextMenu={() => {
          setHandleContext(false);
        }}
        asChild
      >
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent>
        {data?.(row)
          ?.filter((item) => !item.hide)
          .map((item) => {
            const Icon = item?.icon;

            return item.isLink ? (
              <Link to={item.isLink} state={{ id: item?.id }} key={item.name}>
                <ContextMenuItem
                  className={cn(
                    `flex items-center  !pr-5 font-medium gap-2`,
                    item.isTrash && "text-red-600 hover:!text-red-600",
                  )}
                >
                  <Icon size={16} />
                  <span>{item.name}</span>
                </ContextMenuItem>
              </Link>
            ) : (
              <React.Fragment key={item.name}>
                <ContextMenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.onclick) {
                      item.onclick();
                    }
                  }}
                  className={cn(
                    `flex items-center  !pr-5 font-medium gap-2`,
                    item.isTrash && "text-red-600 hover:!text-red-600",
                    item?.textClassName,
                  )}
                >
                  <Icon size={16} />
                  <span>{item.name}</span>
                </ContextMenuItem>
              </React.Fragment>
            );
          })}
      </ContextMenuContent>
    </ContextMenu>
  ) : (
    <>{children}</>
  );
};

export default CustomRightClickActionBtn;
